import { render } from "./deleteHostModal.vue?vue&type=template&id=3b88189f"
import script from "./deleteHostModal.vue?vue&type=script&lang=js"
export * from "./deleteHostModal.vue?vue&type=script&lang=js"
script.render = render

export default script